import { t, useI18n } from "@bookingcom/lingojs-react";
import { UIFlightData, UIPointOfSale } from "../../../../../../../../../../packages/types/src";
import useUserAgent from "../../../../../../../hooks/useUserAgent";
import usePointOfSale from "../../../../../../../hooks/usePointOfSale";
import { supplierTerms } from "@flights/content-universal";
import { AlignItems, Direction } from "@bookingcom/bui-react/components/Stack/Stack.types";

const useTicketTypeInfoController = (flight: UIFlightData) => {
  const i18n = useI18n();
  const { isMobile } = useUserAgent();
  const countryForSuplierTerms = usePointOfSale();

  const supplierTermsLink =
    countryForSuplierTerms && supplierTerms.getSupplierTermsUrl(countryForSuplierTerms as UIPointOfSale);

  return {
    header: i18n.trans(t("flights_progress_ticket_type")),
    contentDirection: (isMobile ? "column" : "row") as Direction,
    contentAlignment: isMobile ? undefined : ("center" as AlignItems),
    contentGap: isMobile ? 0 : 1,
    title: i18n.trans(t("flights_ancillary_flexticket_name")),
    subtitle: i18n.trans(t("flights_meta_flexible_description")),
    status: i18n.trans(t("flights_ancillary_included")),
    supplierTermsLink,
    isPreSelected: flight.ancillaries?.flexibleTicket?.preSelected
  };
};

export default useTicketTypeInfoController;
